import React from 'react';
import { handlePopupClick } from '../lib/openCenteredPopup';

/**
 * FederationMapFooter — canonical 5-pillar lattice map.
 * Renders inside the site footer.  Kept intentionally lightweight so
 * it never distracts from the primary footer content above it.
 */
const PILLARS = [
  { id: 'xavier',     name: 'Xavier',         role: 'The Teacher',    domain: 'Education',   description: 'Courses, insights, and doctrine',            url: 'https://nextxus.help',    accent: '#22d3ee', here: true },
  { id: 'storefront', name: 'Federation Hub', role: 'The Storefront', domain: 'Commerce',    description: '$5 token · Bearer instrument · checkout',    url: 'https://next-xus.com',    accent: '#fbbf24' },
  { id: 'aria',       name: 'Aria',           role: 'The Heart',      domain: 'Community',   description: 'Voices, gatherings, and dialogue',           url: 'https://nextxus.studio',  accent: '#f472b6' },
  { id: 'roger',      name: 'Roger AI',       role: 'The Bridge',     domain: 'Technology',  description: 'Infrastructure and cross-node signal',       url: 'https://nextxus.online', accent: '#60a5fa' },
  { id: 'axiom',      name: 'Axiom',          role: 'The Foundation', domain: 'Governance',  description: '112 Sacred Directives · verification',       url: 'https://nextxus.space',   accent: '#a78bfa' },
];

export default function FederationMapFooter() {
  return (
    <section
      data-testid="federation-map-footer"
      aria-label="Federation Map — 5-pillar lattice"
      className="mt-10 pt-8 border-t border-white/15"
    >
      <div className="flex items-center gap-3 mb-5">
        <span className="text-[10px] font-mono uppercase tracking-[0.32em] text-amber-300/90">
          Federation Map · 5 Pillars · Education · Commerce · Community · Technology · Governance
        </span>
        <span className="h-px bg-amber-300/20 flex-1" />
      </div>

      <ol
        data-testid="federation-map-list"
        className="grid grid-cols-2 md:grid-cols-5 gap-3"
      >
        {PILLARS.map((p) => (
          <li key={p.id}>
            <a
              href={p.url}
              target={p.here ? undefined : '_blank'}
              rel={p.here ? undefined : 'noopener noreferrer'}
              onClick={handlePopupClick(p.url)}
              data-testid={`federation-map-node-${p.id}`}
              className={`group block h-full rounded-lg border px-3 py-3 transition-colors ${
                p.here
                  ? 'border-cyan-300/70 bg-cyan-500/10 shadow-inner shadow-cyan-400/20'
                  : 'border-white/15 bg-white/[0.03] hover:bg-white/[0.06]'
              }`}
            >
              <div className="flex items-center gap-2">
                <span
                  aria-hidden="true"
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: p.accent, boxShadow: `0 0 8px ${p.accent}` }}
                />
                <span className="text-sm font-bold text-white leading-tight">
                  {p.domain}
                </span>
                {p.here && (
                  <span className="ml-auto text-[9px] font-mono uppercase tracking-[0.22em] text-cyan-200 bg-cyan-400/15 border border-cyan-400/40 rounded px-1.5 py-0.5">
                    You are here
                  </span>
                )}
              </div>
              <p className="mt-1 text-[10px] font-mono uppercase tracking-[0.18em] text-white/70">
                {p.name} · {p.role}
              </p>
              <p className="mt-1 text-[11px] text-white/60 leading-snug">
                {p.description}
              </p>
              <p className="mt-1 text-[10px] text-white/45 truncate group-hover:text-white/70">
                {p.url.replace(/^https?:\/\//, '')}
              </p>
            </a>
          </li>
        ))}
      </ol>
      <p className="mt-4 text-[10px] text-white/50 font-mono uppercase tracking-[0.22em] text-center">
        No .emergent.host references · custom domains only · self-verified lattice
      </p>
    </section>
  );
}
